import { takeEvery, put, call, all } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getNotificationsEmails(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-product-notification/" + actions.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "RESPONSE_GET_NOTIFICATIONS_EMAILS", value: response });
  } catch (error) {
    yield put({ type: "RESPONSE_GET_NOTIFICATIONS_EMAILS", value: error });
  }
}

function* createNotificationsEmail(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-product-notifications/" + actions.productUuid;;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";

    if (response) {
      if (response.createdAt || response[0].createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "RESPONSE_CREATE_NOTIFICATIONS_EMAILS", value: { ...response, responseStatus } });

    return response;
  } catch (error) {
    yield put({ type: "RESPONSE_CREATE_NOTIFICATIONS_EMAILS", value: { ...error, responseStatus: "error" } });
    throw error;
  }
}

function* updateNotificationsEmail(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-product-notification/" + actions.productUuid + "/" + actions.notificationEmailUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "RESPONSE_UPDATE_NOTIFICATIONS_EMAILS", value: { ...response, responseStatus } });

    return response;
  } catch (error) {
    yield put({ type: "RESPONSE_UPDATE_NOTIFICATIONS_EMAILS", value: { ...error, responseStatus: "error" } });
    throw error;
  }
}

function* deleteNotificationsEmail(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-product-notification/" + actions.productUuid + "/" + actions.notificationEmailUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);


    let responseStatus = "warning";
    if (response) {
      if (response.status === 200) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "RESPONSE_DELETE_NOTIFICATIONS_EMAILS", value: { ...response, responseStatus } });

    return response;
  } catch (error) {
    yield put({ type: "RESPONSE_DELETE_NOTIFICATIONS_EMAILS", value: { ...error, responseStatus: "error" } });
    throw error;
  }
}


export function* getSagaNotificationsEmails() {
  yield takeEvery("GET_NOTIFICATIONS_EMAILS", getNotificationsEmails);
}

export function* createSagaNotificationsEmails() {
  yield takeEvery("CREATE_NOTIFICATIONS_EMAILS", createNotificationsEmail);
}

export function* updateSagaNotificationsEmails() {
  yield takeEvery("UPDATE_NOTIFICATIONS_EMAILS", updateNotificationsEmail);
}

export function* deleteSagaNotificationsEmail() {
  yield takeEvery("DELETE_NOTIFICATIONS_EMAILS", deleteNotificationsEmail);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
